import React from 'react';
import { Form, FormItemProps } from 'antd';
import { JLabel } from '../JLabel';

export const JInputWrapper: React.FC<FormItemProps> = ({
  children,
  label,
  ...props
}) => {
  return (
    <Form.Item
      label={<JLabel label={label} />}
      labelCol={props?.labelCol || { span: 24 }}
      wrapperCol={props?.wrapperCol || { span: 24 }}
      {...props}
    >
      {children}
    </Form.Item>
  );
};
